// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 2H2V15H7V7H15V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 9H9V15H15V9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 17H17V9H22V22H9V17Z"}}]};

const RelativityFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'relativity-filled',
    ref,
    icon: element,
  },
));

RelativityFilledIcon.displayName = 'RelativityFilledIcon';

export default RelativityFilledIcon;
